import { AUTHOR, MEDIA_STATUS } from '@constants/profiles-media';

export const getMediaAction = (mediaItem, { onDelete, onReport, onUndoReport }) => {
    if (!mediaItem) return null;

    if (mediaItem.authorType === AUTHOR.BUSINESS) {
        return { labelKey: 'buttons.delete', buttonType: 'danger', run: () => onDelete(mediaItem) };
    }
    if (mediaItem.status === MEDIA_STATUS.REPORTED) {
        return { labelKey: 'buttons.undoReport', buttonType: 'outlined', run: () => onUndoReport(mediaItem) };
    }
    if (mediaItem.takedownUrl) {
        return { labelKey: 'buttons.report', buttonType: 'danger', run: () => onReport(mediaItem) };
    }
    return null;
};
